import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  FormControlLabel,
  FormGroup,
  Grid2,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import * as Yup from "yup"
import {
  AccountTree,
  Architecture,
  Code,
  DeveloperMode,
  People,
  Rocket,
  SettingsSuggest,
} from "@mui/icons-material";
import AutoSlider from "./AutoSlider";
import  {toast } from "react-toastify";
import axios from "axios"
import { useSearchParams } from "react-router-dom";


const ContactUs = () => {
  const isMobile = window.innerWidth <= 768;

  const [searchParams,setSearchParams]=useSearchParams()
  const getProductDemo=searchParams.get("demo")
  const getType=searchParams.get("type")
  const [contactInfo, setContactInfo] = useState({
    type: (getType!==undefined)||(getType!==null)?[getType]:[],
    service: [],
    productDemo:(getProductDemo!==undefined)||(getProductDemo!==null)?[getProductDemo]:[],
    name: "",
    email: "",
    phoneno: "",
  });
  const [mail,setMail]=useState(false)
  const handleContact = (name, value,checked) => {
    if(checked){
      setContactInfo({
        ...contactInfo,
        [name]: [...contactInfo[name],value],
      });
    }else{
      const filterData=contactInfo[name].filter((fil)=>fil!==value)
      if((value==="Product Demo")){
        setContactInfo({...contactInfo, [name]: filterData,productDemo:[]})
      }else{
        setContactInfo({
          ...contactInfo,
          [name]: filterData,
        });
      }
      
    }
    // setContactInfo({
    //   ...contactInfo,
    //   [name]: value,
    // });
  };
  const handleText=(name,value)=>{
    setContactInfo({
      ...contactInfo,
      [name]: value,
    });
  }
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
  
    
  });

  const handleSend=()=>{
    setMail(true)
    console.log(contactInfo)
  validationSchema
    .validate(contactInfo, { abortEarly: false })
    .then((responseData) => {
      // setError({});
      // setConfirm({ ...confirm, submit: true });
      // setConfirmValue([postData]);
      const templateParams = {
        name:contactInfo.name,
        email: contactInfo.email,
        type: contactInfo.type.toString(),
        service:contactInfo.service.toString(),
        phoneno:contactInfo.phoneno,
        demo:contactInfo.productDemo.toString(),
      };
      console.log(templateParams)
      // emailjs
      // .send("service_3swv2pq","template_gkae2wi", {
      //   name: "kavya",
      //   email: "test@gmail.com",
      //   type: "test",
      //   service:"",
      //   phoneno: "9876654331",
      //   }, "Q0mt722y--bfQQ7T-")
      // .then(
      //   () => {
      //     console.log('SUCCESS!');
      //   },
      //   (error) => {
      //     console.log('FAILED...', error);
      //   },
      // );
      const data = {
        service_id: 'service_3swv2pq',
        template_id: 'template_gkae2wi',
        user_id: 'Q0mt722y--bfQQ7T-',
        template_params: templateParams
    };
    axios.post ("https://api.emailjs.com/api/v1.0/email/send",data).then(res=>{
      console.log(res)
      toast.success(<Box sx={{p:{xs:"0.5rem",md:"1.5rem"}}}>
        <Typography sx={{fontSize:{xs:"0.8rem",md:"1.2rem"}}}>Hi {contactInfo.name},
         Thanks for reaching out! We appreciate your interest and will get back to you soon after reviewing your request.<br/>
         <br/>
           Feel free to contact us if you have any questions.<br/>
           <br/>
           Thanks again!
           </Typography>
      </Box>,{style:{width:isMobile?"100%":"60vw",background:"#0c76e1"}})
      setMail(false)
    }).catch(e=>{
       toast.error("Email Not Send")
       setMail(false)
      console.log(e)
    })
      
      console.log("no validation errors");
      // console.log(responseData);
    })
    .catch((err) => {
      setMail(false)
      console.log(err)
      const errors = err.inner.reduce((acc, error) => {
        return {
          ...acc,
          [error.path]: error.errors[0],
        };
      }, {});
      console.log(errors);
      
      toast.error(<Box>
        <Typography sx={{display:errors.name===undefined?"none":"default"}}>{errors.name}</Typography>
        <Typography sx={{display:errors.email===undefined?"none":"default"}}>{errors.email}</Typography>
      </Box>);
    });
    
  }
  return (
    <Grid2 container justifyContent={"center"} spacing={"1rem"} sx={{p:"1.5rem"}}>
      <Grid2
        container
        // alignItems={"center"}
        justifyContent={"center"}
        sx={{
          // mt: { xs: "30%", md: "15%", lg: "10%", xl: "6%" },
          mt:"15vh",
          p: "1rem",
          maxWidth: { xs: "auto", xl: "2000px" },
          // maxHeight:{xs:"auto",md:"87vh"},
          boxShadow: 3,
        }}
        // sx={{ p: { xs: "4rem 1rem 0 1rem", md: "4rem 2rem 0 2rem" } }}
      >
        <Grid2
          size={{ xs: 12, md: 7 }}
          // sx={{ maxWidth:{xs:"auto",xl:"2000px"}, }}
        >
          <Paper
            elevation={0}
            sx={{
              padding: "1rem",
              borderRadius: 0,
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              height: "100%",
              // width: { xs: "100", md: "96%", lg: "76%" },
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: commonCss.mainTitleFontSize,
                  fontWeight: commonCss.mainTitleFontWeight,
                }}
              >
                Let’s talk about your project
              </Typography>
              <Typography sx={{ fontSize: "0.93rem", mt: 1 }}>
                Our team will review your submission and connect with you within
                24 hours.
              </Typography>
            </Box>
            <Grid2
              container
              sx={{ p: { xs: 0, md: "0rem 1.5rem" } }}
              spacing={"1rem"}
            >
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: commonCss.mainTitleFontSize,
                    fontWeight: commonCss.mainTitleFontWeight,
                    mb: "1rem",
                  }}
                >
                  What can we do for you?
                </Typography>
                <FormGroup
                  value={contactInfo.type}
                  onChange={(e) => {
                   
                    handleContact("type",e.target.value, e.target.checked);
                  }}
                >
                  <FormControlLabel
                    value="Build a new project"
                    control={<Checkbox />}
                    label="Build a new project"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Scale an existing project"
                    control={<Checkbox />}
                    label="Scale an existing project"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Outsourcing"
                    control={<Checkbox />}
                    label="Outsourcing"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                   checked={contactInfo.type.includes("Product Demo")}
                    value="Product Demo"
                    control={<Checkbox />}
                    label="Product Demo"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                </FormGroup>
                <Collapse in={contactInfo.type.includes("Product Demo")} sx={{pl:"1rem"}}>
                <FormGroup
                  value={contactInfo.productDemo}
                  onChange={(e) => {
                    
                    handleContact("productDemo",e.target.value, e.target.checked);
                  }}
                >
                  <FormControlLabel
                   checked={contactInfo.productDemo.includes("Enterprise Asset Management")}
                    value="Enterprise Asset Management"
                    control={<Checkbox />}
                    label="Enterprise Asset Management"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                  checked={contactInfo.productDemo.includes("Internet Booking Platform")}
                    value="Internet Booking Platform"
                    control={<Checkbox />}
                    label="Internet Booking Platform"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                  checked={contactInfo.productDemo.includes("Permit To Work")}
                    value="Permit To Work"
                    control={<Checkbox />}
                    label="Permit To Work"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                   checked={contactInfo.productDemo.includes("Safety Walk")}
                    value="Safety Walk"
                    control={<Checkbox />}
                    label="Safety Walk"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                  checked={contactInfo.productDemo.includes("Security e-Form")}
                    value="Security e-Form"
                    control={<Checkbox />}
                    label="Security e-Form"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                  checked={contactInfo.productDemo.includes("Online Job Training")}
                    value="Online Job Training"
                    control={<Checkbox />}
                    label="Online Job Training"
                     sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                </FormGroup>
                </Collapse>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: commonCss.mainTitleFontSize,
                    fontWeight: commonCss.mainTitleFontWeight,
                    mb: "1rem",
                  }}
                >
                  What type of support do you need?
                </Typography>
                <FormGroup
                  value={contactInfo.service}
                  onChange={(e) => {
                    handleContact("service",e.target.value, e.target.checked);
                  }}
                >
                  <FormControlLabel
                    value="Development"
                    control={<Checkbox />}
                    label="Development"
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Design"
                    control={<Checkbox />}
                    label="Design"
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Development & Design"
                    control={<Checkbox />}
                    label="Development & Design"
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Others"
                    control={<Checkbox />}
                    label="Others"
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.9rem", // or any size you prefer (e.g., '14px', '0.875rem')
                      },
                    }}
                  />
                </FormGroup>
              </Grid2>
              {/* <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  // flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "0.5rem",
                    border:
                      contactInfo.type === "Build a new project"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("type", "Build a new project");
                  }}
                >
                  <Rocket
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Build a new project
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  // flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "0.5rem",
                    border:
                      contactInfo.type === "Scale an existing project"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("type", "Scale an existing project");
                  }}
                >
                  <Architecture
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Scale an existing project
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  // flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "0.5rem",
                    border:
                      contactInfo.type === "Outsourcing"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("type", "Outsourcing");
                  }}
                >
                  <People
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Outsourcing
                </Typography>
              </Box>
            </Grid2> */}
            </Grid2>
            {/* <Grid2
              container
              sx={{ p: { xs: 0, md: "0 1.5rem" } }}
              spacing={"1rem"}
            >
              <Grid2 size={12}>
                <Typography
                  sx={{
                    fontSize: commonCss.mainTitleFontSize,
                    fontWeight: commonCss.mainTitleFontWeight,
                  }}
                >
                  What type of support do you need?
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    // flexDirection: "column",
                    gap: "1rem",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                      padding: "0.5rem",
                      border:
                        contactInfo.service === "Development"
                          ? `1px solid ${commonCss.blue}`
                          : "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleContact("service", "Development");
                    }}
                  >
                    <Code
                      sx={{
                        fontSize: commonCss.cardIconSize,
                        color: commonCss.blue,
                      }}
                    />
                  </Paper>
                  <Typography
                    sx={{
                      fontWeight: commonCss.cardTitleWeight,
                      fontSize: commonCss.cardTitleSize,
                    }}
                  >
                    Development
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    // flexDirection: "column",
                    gap: "1rem",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                      padding: "0.5rem",
                      border:
                        contactInfo.service === "Design"
                          ? `1px solid ${commonCss.blue}`
                          : "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleContact("service", "Design");
                    }}
                  >
                    <AccountTree
                      sx={{
                        fontSize: commonCss.cardIconSize,
                        color: commonCss.blue,
                      }}
                    />
                  </Paper>
                  <Typography
                    sx={{
                      fontWeight: commonCss.cardTitleWeight,
                      fontSize: commonCss.cardTitleSize,
                    }}
                  >
                    Design
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    // flexDirection: "column",
                    gap: "1rem",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                      padding: "0.5rem",
                      border:
                        contactInfo.service === "Development & Design"
                          ? `1px solid ${commonCss.blue}`
                          : "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleContact("service", "Development & Design");
                    }}
                  >
                    <DeveloperMode
                      sx={{
                        fontSize: commonCss.cardIconSize,
                        color: commonCss.blue,
                      }}
                    />
                  </Paper>
                  <Typography
                    sx={{
                      fontWeight: commonCss.cardTitleWeight,
                      fontSize: commonCss.cardTitleSize,
                    }}
                  >
                    Development & Design
                  </Typography>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, lg: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    // flexDirection: "column",
                    gap: "1rem",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                      padding: "0.5rem",
                      border:
                        contactInfo.service === "Others"
                          ? `1px solid ${commonCss.blue}`
                          : "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleContact("service", "Others");
                    }}
                  >
                    <SettingsSuggest
                      sx={{
                        fontSize: commonCss.cardIconSize,
                        color: commonCss.blue,
                      }}
                    />
                  </Paper>
                  <Typography
                    sx={{
                      fontWeight: commonCss.cardTitleWeight,
                      fontSize: commonCss.cardTitleSize,
                    }}
                  >
                    Others
                  </Typography>
                </Box>
              </Grid2>
            </Grid2> */}
            <Grid2
              container
              sx={{ p: { xs: 0, md: "0 1.5rem" } }}
              spacing={"1rem"}
            >
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  name="name"
                  label={
                    <span style={{color:commonCss.darkGray,opacity: 0.9,}}>
                    Your Name
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                  }
                  // placeholder="Your Name"
                  value={contactInfo.name}
                  onChange={(e) => handleText(e.target.name, e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: commonCss.contactUsTextboxGray,
                      },
                    },
                    // input: {
                    //   "&::placeholder": {
                    //     color: commonCss.darkGray,
                    //     opacity: 0.9,
                    //   },
                    // },
                  }}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  type="email"
                  fullWidth
                  name="email"
                  label={
                    <span style={{color:commonCss.darkGray,opacity: 0.9,}}>
                    Your Email
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                  }
                  // placeholder="Your Email*"
                  value={contactInfo.email}
                  onChange={(e) => handleText(e.target.name, e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: commonCss.contactUsTextboxGray,
                      },
                    },
                    // input: {
                    //   "&::placeholder": {
                    //     color: commonCss.darkGray,
                    //     opacity: 0.9,
                    //   },
                    // },
                  }}
                />
              </Grid2>
              <Grid2 size={12}>
                <TextField
                  fullWidth
                  name="phoneno"
                  label={
                    <span style={{color:commonCss.darkGray,opacity: 0.9,}}>
                      Your Phone Number
                    </span>
                  }
                  // placeholder="Your Phone Number"
                  value={contactInfo.phoneno}
                  onChange={(e) => handleText(e.target.name, e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: commonCss.contactUsTextboxGray,
                      },
                    },
                    // input: {
                    //   "&::placeholder": {
                    //     color: commonCss.darkGray,
                    //     opacity: 0.9,
                    //   },
                    // },
                  }}
                />
              </Grid2>
              <Grid2 container size={12} justifyContent={"flex-end"}>
                <Button
                disabled={mail}
                  sx={{
                    backgroundColor: commonCss.buttonBg,
                    color: commonCss.buttonText,
                    padding: "0.5rem",
                    textTransform: "none",
                    width: { xs: "40%", md: "25%" },
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    borderRadius: "30px",
                    ":hover": {
                      background: commonCss.blue,
                    },
                  }}
                  onClick={handleSend}
                >
                 <CircularProgress  sx={{display:mail?"default":"none",color:"white",fontSize: "0.7rem",}}/> Send mail
                </Button>
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 5 }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.798383368423!2d101.68910707447043!3d3.1478328531617836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc493bc127be79%3A0x366d628839b4e09b!2sSolver%20Thoughts%20Technologies!5e0!3m2!1sen!2sin!4v1745390761423!5m2!1sen!2sin"
            // width="100%"
            // height="500"
            style={{ border: 0,height:contactInfo.type.includes("Product Demo")?"100vh":"550px",width:"100%" }}
            frameborder="0"
            loading="eager"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </Grid2>
      </Grid2>
      <Grid2
        container
        size={12}
        sx={{ background: commonCss.backgroundGray, padding: "2rem" }}
      >
        <Grid2 size={12}>
          <Grid2 size={12}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 550,
                textAlign: "center",
                mt: "1rem",
                mb: "0.5rem",
              }}
            >
              Our partners share their stories
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          sx={{ maxWidth: { xs: "auto", xl: "2000px" } }}
        >
          <AutoSlider />
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default ContactUs;
